import CoreBase from '../../../../services/engines/CoreBase';
import { injectMetaData } from '../renderers/MetaDataInjector';
import userSettingsEngine from '../../../../controllers/UserSettings/UserSettingsEngine';

class DataEnricher extends CoreBase {
    _name = 'DataEnricher';

    /**
     * Parses entry body and enriches with metadata and user settings.
     * @param {object} entry - data note entry object
     * @returns {{ enriched: object, settings: object }|null}
     */
    enrich(entry) {
        if (!entry?.body) return null;

        try {
            const parsed = JSON.parse(entry.body);

            const dateFormat = userSettingsEngine.resolve('contentPanel.chipDateTimeFormat');

            const settings = {
                dayparts: {
                    night:     userSettingsEngine.resolve('contentPanel.daypart.night'),
                    morning:   userSettingsEngine.resolve('contentPanel.daypart.morning'),
                    afternoon: userSettingsEngine.resolve('contentPanel.daypart.afternoon'),
                    evening:   userSettingsEngine.resolve('contentPanel.daypart.evening'),
                },
            };

            const enriched = injectMetaData(parsed, entry, null, dateFormat);

            return { enriched, settings };
        } catch (e) {
            this.logError(`enrich: body is not valid JSON — ${e.message}`);
            return null;
        }
    }
}

const dataEnricher = new DataEnricher();
export default dataEnricher;
